import { EOrganizationFeature } from 'types/enum';
import type { TCurrentUser } from 'types/user';
import type { TOrganizationFeatures } from 'types/organization';

export const DISABLED_ORGANIZATION_FEATURES: TOrganizationFeatures = {
  [EOrganizationFeature.TAG_MANAGEMENT]: false,
  [EOrganizationFeature.BULK_SEND_TAGGING]: false,
  [EOrganizationFeature.SURVEY]: false,
  [EOrganizationFeature.STEP_DELIVERY]: false,
};

// 画面の出し分けだけ。未定義（未取得・旧API）は有効扱いで、実際の制限はバックエンドが行う。
export function isOrganizationFeatureEnabled(
  user: Pick<TCurrentUser, 'organizationFeatures'> | undefined,
  feature: EOrganizationFeature,
): boolean {
  const features = user?.organizationFeatures;
  if (!features) return true;
  return features[feature];
}

// 機能APIを取得してよいか。現在ユーザーの取得前は機能が分からないので取得しない（OFFの組織で403を出さない）。
export function canFetchOrganizationFeature(
  user: Pick<TCurrentUser, 'organizationFeatures'> | undefined,
  feature: EOrganizationFeature,
): boolean {
  return user !== undefined && isOrganizationFeatureEnabled(user, feature);
}
